var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.163,
    height: 73.413,
    viewBox: "0 0 73.163 73.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20b038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60d66a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_42",
    x: 0,
    y: 0,
    width: 73.163,
    height: 73.413,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp-circle",
    transform: "translate(7.679 5.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M49.381,8.44a28.783,28.783,0,0,0-45.3,34.716L0,58.065l15.257-4a28.761,28.761,0,0,0,13.753,3.5h.012A28.783,28.783,0,0,0,49.381,8.44ZM29.023,52.707h-.009a23.894,23.894,0,0,1-12.177-3.335l-.872-.517L6.909,51.229,9.327,42.4l-.57-.9A23.922,23.922,0,1,1,29.021,52.705Z",
    transform: "translate(0 -0.002)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.68, -5)",
    filter: "url(#Path_42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M27.875,76.485l3.9-14.23a27.467,27.467,0,1,1,23.8,13.752h-.012a27.452,27.452,0,0,1-13.117-3.339L27.877,76.483Z",
    transform: "translate(-18.88 -15.07)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    d: "M22.121,23.785H54.446V54.072H22.121Z",
    transform: "translate(-9.277 -9.974)",
    fill: "none",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M32.429,27.614c-.532-1.184-1.093-1.208-1.6-1.228-.415-.018-.889-.017-1.362-.017a2.613,2.613,0,0,0-1.9.89,7.969,7.969,0,0,0-2.489,5.928c0,3.5,2.548,6.878,2.9,7.352S32.9,48.42,40.129,51.269c6,2.368,7.227,1.9,8.531,1.778s4.205-1.719,4.8-3.379a5.936,5.936,0,0,0,.415-3.38c-.178-.3-.651-.474-1.363-.83s-4.205-2.076-4.858-2.313-1.126-.355-1.6.357-1.835,2.311-2.251,2.787-.83.534-1.54.179a19.445,19.445,0,0,1-5.716-3.528,21.411,21.411,0,0,1-3.955-4.923c-.415-.711-.045-1.1.312-1.452.319-.318.711-.83,1.067-1.245a4.877,4.877,0,0,0,.71-1.185,1.309,1.309,0,0,0-.058-1.245c-.179-.356-1.561-3.871-2.193-5.277Z",
    transform: "translate(-10.519 -11.058)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M49.386,8.345A28.451,28.451,0,0,0,4.607,42.661L.571,57.4l15.082-3.955a28.431,28.431,0,0,0,13.6,3.462h.012A28.451,28.451,0,0,0,49.386,8.345ZM29.26,52.105h-.006a23.62,23.62,0,0,1-12.038-3.3l-.862-.511L7.4,50.644l2.389-8.726-.563-.894A23.648,23.648,0,1,1,29.26,52.1Z",
    transform: "translate(-0.241 0.254)",
    fill: "#fff",
    stroke: "#4ac959",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.c19677b321454c965bc901bc3aa84edb.svg";
export { ForwardRef as ReactComponent };